module.exports = __webpack_public_path__ + "static/media/lumpnotes_android.0c1ff469.png";